// extracted by mini-css-extract-plugin
export default {"detailsGrid":"detailsGrid-VL0zVI67"};